module.exports = __webpack_public_path__ + "static/commarts.d36ec9a3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/commarts.pdf
// module id = 367
// module chunks = 174759553322802